import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { PlanetLogo } from "@/components/PlanetLogo";
import { SiteFooter } from "@/components/SiteFooter";

// Gemeinsames Layout fuer rechtliche Seiten (Impressum, Datenschutz).
export const LegalLayout = ({ badge, title, children, testId }) => {
  return (
    <div className="relative min-h-screen overflow-hidden" data-testid={testId}>
      <div className="relative z-20">
        <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-4 sm:px-6">
          <Link to="/" data-testid="legal-logo-link" className="flex items-center gap-2">
            <PlanetLogo />
            <span className="font-display text-sm font-bold tracking-[0.14em] text-white">
              GALAXY <span className="text-gl-blue2">LEAGUE</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-xs tracking-[0.16em] text-white/65 transition-colors hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" />
            ZURÜCK
          </Link>
        </div>
      </div>

      <section className="hero-glow relative">
        <div className="mx-auto max-w-3xl px-4 pb-16 pt-8 sm:px-6">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="inline-flex items-center rounded-full border border-gl-blue/40 bg-gl-blue/10 px-4 py-1.5 text-[11px] font-semibold tracking-[0.18em] text-gl-blue2">
              {badge}
            </span>
            <h1 className="mt-6 font-display text-4xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-5xl">
              {title}
            </h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="legal-prose mt-10 space-y-8 text-sm leading-relaxed text-white/70"
          >
            {children}
          </motion.div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <div>
    <h2 className="mb-3 font-display text-base font-bold uppercase tracking-[0.1em] text-white">
      {heading}
    </h2>
    <div className="space-y-3">{children}</div>
  </div>
);
